// extracted by mini-css-extract-plugin
export default {"userForm":"user-form_userForm__HDvR4","save":"user-form_save__XV9ZU"};